import { SET_BULK_PARAMS_CLIENT_CLASSIFICATION, CLEAR_PARAMS_CLIENT_CLASSIFICATION, SET_PARAMS_CLIENT_CLASSIFICATION } from "constants/types";

const initialState = {
    search: "",
    page: 1,
    size: 10,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_CLIENT_CLASSIFICATION:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_PARAMS_CLIENT_CLASSIFICATION:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_CLIENT_CLASSIFICATION:
            return {
                ...state,
                search: "",
                page: 1,
            };
        default:
            return state;
    }
}
